import { render, staticRenderFns } from "./MobileHomeEntries.vue?vue&type=template&id=4d63d590&scoped=true&"
import script from "./MobileHomeEntries.vue?vue&type=script&lang=ts&"
export * from "./MobileHomeEntries.vue?vue&type=script&lang=ts&"
import style0 from "./MobileHomeEntries.vue?vue&type=style&index=0&id=4d63d590&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d63d590",
  null
  
)

export default component.exports